import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { VOID_STUDENT_PAYMENT } from "../../Schema/StudentPayment";
import { translateLauguage } from "../../Function/Translate";

export default function VoidInvoice({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [voidPayment] = useMutation(VOID_STUDENT_PAYMENT, {
    onCompleted: ({ voidPayment }) => {
      setLoading(false);
      if (voidPayment?.status === true) {
        setAlert(true, "success", voidPayment?.message);
        handleClose();
        setRefetch();
      } else {  
        setAlert(true, "error", voidPayment?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    voidPayment({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Void invoice</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} /> 
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>Do you really want to void this invoice?</Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                Void
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
